<template>
    <div v-if="goodsLevel" class="goods-level-box">
        <img class="bgImg" :src="$util.imgLevel(goodsLevel.bg_image)" alt=""/>
        <img v-if="goodsLevel.icon" class="icon" :src="$util.img(goodsLevel.icon)" alt=""/>
        <span :class="{'iconRight':goodsLevel.icon}">{{ goodsLevel.name }}</span>
    </div>

</template>

<script>
export default {
    props: {
       goods: {
			type: Object,
			required: true,
			default: () => {
				return {}
			}
		},
    },
    data() {
        return {
        }
    },
    computed: {
        goodsLevel() {
            return this.goods.goods_level;
        }
    },
    mounted() {
    },
    methods: {}
}
</script>
<style lang="scss" scoped>
.goods-level-box{
    position: relative;
    padding: 6px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 6px;
    // background-color: rgba(0,0,0,0.5);
    >.bgImg{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
    }
    >.icon{
        position: relative;
        z-index: 2;
        height: 12px;
    }
    >span{
        position: relative;
        z-index: 2;
        color: #fff;
        font-size: 12px;
        line-height: 1;
        margin-right: 12px;
        font-weight: bold;
        white-space: nowrap;
    }
    .iconRight{
        margin-right: 12px;
    }
}
</style>